export const CASINO_LEADER_BOARD_DETAILS = 'casino-leaderboard-page';

export const COMPETITORS_VS_PRIZES_POSITION = {
    vertical: 'vertical',
    horizontal: 'horizontal'
};

export const COMPETITORS_VS_PRIZES_VIEW = {
    vertical: 'row',
    horizontal: 'column'
};

export const PRIZES_VIEW = {
    vertical: 'column',
    horizontal: 'row'
};

export const DISPLAY_PLAYER = {
    username: 'username',
    nicknameByNetworkType: 'nicknameByNetworkType',
    nicknameByNetworkId: 'nicknameByNetworkId'
};
